const ClaimOwnershipCard = ({
  candidateName,
  isClaimed = false,
  isOwnedByCurrentUser = false,
  hasPendingClaim = false,
  onClaim,
  onManage,
}) => {
  const heading = isOwnedByCurrentUser
    ? `You already own ${candidateName}'s profile`
    : hasPendingClaim
      ? `Ownership request received for ${candidateName}`
    : `Do You Want To Claim Ownership Of "${candidateName}'s" profile?`;

  const description = isOwnedByCurrentUser
    ? "Your ownership is approved. Open your candidate dashboard to manage updates and public communication."
    : hasPendingClaim
      ? "Your verification request is under review. You can reopen the candidate dashboard once the admin approves it."
    : isClaimed
      ? "This profile is already claimed and verified by another account."
      : "Take ownership to share your vision & manifesto with the citizens of India.";

  return (
    <div className="mt-10 rounded-xl border-2 border-orange-400 bg-white p-6 text-center shadow-xl md:p-8">
      <h2 className="mb-2 text-2xl font-bold text-orange-600 md:text-3xl">
        {heading}
      </h2>

      <p className="mb-6 text-sm font-medium italic text-gray-700 md:text-base">
        {description}
      </p>

      {isOwnedByCurrentUser ? (
        <button
          type="button"
          onClick={onManage}
          className="inline-block rounded-lg bg-gradient-to-r from-green-600 to-green-700 px-6 py-3 font-bold text-white shadow-md transition hover:from-green-700 hover:to-green-800"
        >
          Open Candidate Dashboard
        </button>
      ) : (
        <button
          type="button"
          onClick={onClaim}
          disabled={isClaimed || hasPendingClaim}
          className="inline-block rounded-lg bg-gradient-to-r from-orange-500 to-green-600 px-6 py-3 font-bold text-white shadow-md transition hover:from-orange-600 hover:to-green-700 disabled:cursor-not-allowed disabled:from-slate-300 disabled:to-slate-400"
        >
          {hasPendingClaim ? "Claim Submitted" : "Take Ownership"}
        </button>
      )}
    </div>
  );
};

export default ClaimOwnershipCard;
